<template>
  <ChatThreadView
    v-if="activeDMThreadId"
    :key="activeDMThreadId"
    :thread-id="activeDMThreadId"
    @back="openDMThread(null)"
  />
  <ChatThreadList
    v-else
    @open-thread="openDMThread"
  />
</template>

<script setup>
import { useChatUI } from '~/composables/chat/useChatUI'

const { activeDMThreadId, openDMThread } = useChatUI()
</script>
